import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ContactDetail from "./pages/ContactDetail";
import Networking from "./pages/Networking";
import Expenses from "./pages/Expenses";
import FollowUps from "./pages/FollowUps";
import Marketing from "./pages/Marketing";
import COIContacts from "./pages/contacts/COIContacts";
import ProspectContacts from "./pages/contacts/ProspectContacts";
import LinkedInContacts from "./pages/contacts/LinkedInContacts";
import DailyTodo from "./pages/operations/DailyTodo";
import Pipeline from "./pages/operations/Pipeline";
import CallingActivity from "./pages/operations/CallingActivity";
import ProfessionalIntroductions from "./pages/operations/ProfessionalIntroductions";
import CallSchedule from "./pages/operations/CallSchedule";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-neutral-500">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="contacts" element={<Navigate to="/contacts/coi" replace />} />
            <Route path="contacts/coi" element={<COIContacts />} />
            <Route path="contacts/prospects" element={<ProspectContacts />} />
            <Route path="contacts/linkedin" element={<LinkedInContacts />} />
            <Route path="contacts/profile/:id" element={<ContactDetail />} />
            <Route path="networking" element={<Networking />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="follow-ups" element={<FollowUps />} />
            <Route path="marketing" element={<Marketing />} />
            <Route path="operations/daily" element={<DailyTodo />} />
            <Route path="operations/pipeline" element={<Pipeline />} />
            <Route path="operations/calling" element={<CallingActivity />} />
            <Route path="operations/intros" element={<ProfessionalIntroductions />} />
            <Route path="operations/schedule" element={<CallSchedule />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
